// extracted by mini-css-extract-plugin
export default {"facilityName":"FacilityInfo_facilityName__1m0aD","scrollableSection":"FacilityInfo_scrollableSection__F73qe"};